import React from 'lib/react';
import {
  EVPaper,
  EVGrid,
  EVSkeleton,
} from 'lib/components';
import AccountsSummaryStyles from './AccountsSummaryStyles';

function AccountsSummaryLoader() {
  const classes = AccountsSummaryStyles();

  return (
    <EVPaper className={classes.accountsSummaryPaper}>
      <EVGrid className={classes.topSection}>
        <EVGrid className={classes.companyNameSection} style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <EVSkeleton style={{ height: '30px', width: '30%', borderRadius: '6px' }} animation="wave" variant="rect" />
          <EVSkeleton style={{ height: '30px', width: '30%', borderRadius: '6px' }} animation="wave" variant="rect" />
          <EVSkeleton style={{ height: '30px', width: '30%', borderRadius: '6px' }} animation="wave" variant="rect" />
        </EVGrid>
      </EVGrid>
      <EVGrid className={classes.bottomSection}>
        <EVSkeleton style={{ height: '30px', width: '30%', borderRadius: '6px' }} animation="wave" variant="rect" />
        <EVGrid className={classes.orderDetailsContainer}>
          <EVGrid className={classes.orderDetailsBox}>
            <EVSkeleton style={{ height: '30px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />
          </EVGrid>
          <EVGrid className={classes.orderDetailsBox}>
            <EVSkeleton style={{ height: '30px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />
          </EVGrid>
          <EVGrid className={classes.orderDetailsBox}>
            <EVSkeleton style={{ height: '30px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />
          </EVGrid>
        </EVGrid>
        <EVGrid className={classes.membershipLevelContainer}>
          <EVGrid className={classes.membershipLevelTopContainer}>
            <EVSkeleton style={{ height: '30px', width: '30%', borderRadius: '6px' }} animation="wave" variant="rect" />
            <EVSkeleton style={{ height: '30px', width: '90%', borderRadius: '6px' }} animation="wave" variant="rect" />
            <EVSkeleton style={{ height: '30px', width: '30%', borderRadius: '6px' }} animation="wave" variant="rect" />
          </EVGrid>
          <EVGrid className={classes.yearsSummaryContainer}>
            <EVSkeleton style={{ height: '30px', width: '30%', borderRadius: '6px' }} animation="wave" variant="rect" />
            <EVGrid className={classes.yearsSummaryContentContainer}>
              <EVGrid className={classes.yearsSummaryContentElement}>
                <EVSkeleton style={{ height: '30px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />
              </EVGrid>
              <EVGrid className={classes.yearsSummaryContentElement}>
                <EVSkeleton style={{ height: '30px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />
              </EVGrid>
              <EVGrid className={classes.yearsSummaryContentElement}>
                <EVSkeleton style={{ height: '30px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />
              </EVGrid>
            </EVGrid>
          </EVGrid>
        </EVGrid>
      </EVGrid>
    </EVPaper>

  );
}

export default AccountsSummaryLoader;
